import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var MARKETS_ENDPOINTS = {
    BY_EVENT_ID: '/Markets/GetByEventId'
};
/**
 * MarketsApiClient - client for fetching Markets BFF endpoints
 * @export
 * @class MarketsApiClient
 * @extends {BaseApiClient}
 */
var MarketsApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(MarketsApiClient, _super);
    function MarketsApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fetch markets by id from BFF
     * @param {request} MarketsByEventIdRequest
     * @throws {RequiredError}
     * @memberof MarketsApiClient
     */
    MarketsApiClient.prototype.getByEventId = function (request) {
        var fetchOptions = {
            request: request,
            fetchOptOverride: {}
        };
        return this.executeRequest(MARKETS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    };
    return MarketsApiClient;
}(BaseApiClient));
export { MarketsApiClient };
//# sourceMappingURL=MarketsApiClient.js.map